import React from "react";

const navItems = ["home", "labs", "tools", "certifications", "resume"];

export default function Navbar({ onNavigate }) {
  return (
    <nav className="navbar">
      <ul>
        {navItems.map((item) => (
          <li key={item}>
            <button onClick={() => onNavigate(item)}>{item.charAt(0).toUpperCase() + item.slice(1)}</button>
          </li>
        ))}
      </ul>
    </nav>
  );
}

